import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'un-step-title',
  templateUrl: './step-title.component.html',
  styleUrls: ['./step-title.component.less'],
  standalone: false,
})
export class StepTitleComponent {
  @Input() index: number;
  @Input() unTitle?: string;
  @Input() description?: string;
  @Input() visitCount: number;
  @Input() editMode?: boolean;

  @Input() @HostBinding('class.selected') selected: boolean;
  @Input() @HostBinding('class.visited') visited: boolean;
  @Input() @HostBinding('class.invalid') invalid: boolean;
  @Input() @HostBinding('class.disabled') disabled: boolean;

  get icon(): string {
    if ((this.visitCount > 1 || this.editMode) && !this.invalid)
      return 'check-circle';
    if ((this.visitCount > 1 || this.editMode) && this.invalid)
      return 'exclamation-circle';
    if (this.selected || !this.visited) return '';
    if (!this.invalid) return 'check-circle';
    if (this.invalid) return 'exclamation-circle';
    return '';
  }
}
